module.exports = __webpack_public_path__ + "img/marquee-2.f709ee8e.png";